import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import Text from '../../react-components/Text';
import { intercom } from '../../services/intercom';

export const AuthContainer = styled(Grid)`
  height: 100%;
  overflow-y: auto;
  padding: 20px 40px;
  background: ${RoutalPalette.neutral02n};
`;

export const AuthHeader = styled(Grid)`
  position: absolute;
  top: 20px;
  width: auto !important;
`;

export const AuthContent = styled(Grid)`
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
`;

export const AuthBody = styled(Grid)`
  padding: 24px 20px;
  padding-bottom: 0px;
  width: 100%;
  background: ${RoutalPalette.neutral02n};
  max-width: 420px;
  align-self: center;
`;

export const AuthBodyFooter = styled(Grid)`
  padding: 2px 20px;
  width: 100%;
  max-width: 380px !important;
  align-self: center;
`;

export const AuthFooter = () => {
  return (
    <Grid
      item
      container
      direction="row"
      alignItems="center"
      justifyContent="center"
      style={{
        position: `absolute`,
        bottom: `20px`,
        width: `calc(100% - 80px)`,
      }}
    >
      <Grid item>
        <Text
          style={{
            fontSize: `12px`,
          }}
        >
          © Routal
        </Text>
      </Grid>

      <HSpacer small />

      <Grid item>·</Grid>

      <HSpacer small />

      <Grid item>
        <Text
          style={{
            fontSize: `12px`,
            cursor: `pointer`,
          }}
          intlId="auth.footer.contact"
          onClick={() => {
            intercom.open();
          }}
        />
      </Grid>

      <HSpacer small />

      <Grid item>·</Grid>

      <HSpacer small />

      <Grid item>
        <Text
          style={{
            fontSize: `12px`,
            cursor: `pointer`,
          }}
          intlId="auth.footer.privacy_and_conditions"
          onClick={() => {
            window.open(`https://routal.com/politica-privacidad/`, `_blank`);
          }}
        />
      </Grid>
    </Grid>
  );
};
